import React, { useEffect } from "react";
import { withRouter } from 'react-router-dom';
import { checkoutCreateTest, clearAllPaymentForCreateTestData} from "./../../store/action";
import {connect} from 'react-redux'
import { ActivityIndicator, Text, View, StyleSheet, TouchableOpacity, Image} from 'react-native';
import { Surface } from 'react-native-paper';
import { Styles } from './../../components/UI-Components'


const failImage = require('./../../assets/failedPayment.png');
const successImage = require('./../../assets/paymentSuccess.png')



const Payment = (props) => {
    console.log(props.location)
    // paymentInfo: {
    //     transactionType: FOR_COURSE,
    //     courseId: id,
    //     price: is_discounted
    //       ? discount_price
    //       : actual_price,
    //     appStoreProductId: app_store_product_id,
    //   },
    //   examId: this.state.examId,
    const { state={}} = props.location;
    const { paymentInfo , examId} = state || {};
    const { transactionType, courseId, price , mockSeriesCode=null,  app_store_product_id=null, subjectId=null} = paymentInfo || {};
    const _code = mockSeriesCode || subjectId || courseId;
    const { userDetails } = props;




  
  const options = {
    // key: "rzp_test_HJG5Rtuy8Xh2NB",
    key: "rzp_live_ei1otvuTpCxUAh",
    amount: (parseInt(price, 10) * 100), //  = INR 1
    // name: "5Mantra",
    name: "Athena",
    description: "Learning Courses",
    image: "https://cdn.razorpay.com/logos/7K3b6d18wHwKzL_medium.png",
    handler: function(response) {
      props.checkoutCreateTest(response, null ,price, null, transactionType, _code);
      // alert(response.razorpay_payment_id, mockSeriesCode);
    },
    
    prefill: {
      name: userDetails && userDetails.username,
      contact: userDetails && userDetails.phone,
      email: userDetails && userDetails.email    },
    notes: {
      address: userDetails && userDetails.address
    },
    theme: {
      color: "#F37254",
      hide_topbar: false
    },
    "modal": {
        "ondismiss": function(){
            props.history.push("/Home")
        }
    }
  };

  const openPayModal = options => {
    var rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    if(props.response){
      setTimeout(() => {
        props.history.push('/Home')
      }, 2000)
    }
  }, [props.paymentErrorMessage, props.response]);

  return (
    <>
      {
      !props.loading && !props.paymentErrorMessage && !props.response &&
      <div>
          {openPayModal(options)}
      </div>
      
    }
     {
       props.loading ?
        <div className='loginBox'>
          <View style={{flex: 1, width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
            <ActivityIndicator/>
              
            <Text style={{marginTop: 15, fontSize: 18, fontWeight: 'bold'}}>Please Wait..</Text>
          </View>
        </div>
        :null
      
     }
     {
        props.paymentErrorMessage ?
        <div className='loginBox'>
          <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignSelf: 'center'}}>
              <Surface style={ props.paymentErrorMessage ? {...styles.dialogBox, minHeight:'30%',  marginRight: 10,marginLeft: 10,} : styles.dialogBox}>
                    <View  style={styles.details}>
                        <View style={styles.iconDetails}>
                            <Image source={failImage} style={{width:'100%', height:"100%"}}/>
                        </View>                                  
                        <View style={{marginVertical:15, justifyContent:'center', alignItems:'center'}}>
                            <Text style={styles.mainTitle}>{'Payment Failed'}</Text>                                       
                            <Text style={styles.subTitle}>it seems we have not received Money</Text> 
                            <Text style={{color: 'red', marginTop: 8}} >{typeof props.paymentErrorMessage === 'string' && props.paymentErrorMessage}</Text>
                      </View>
                      <View style={styles.goBackWrapper}>
                        <TouchableOpacity                           
                            style={{marginTop: 10}}         
                            onPress={() => props.history.goBack()}
                        >
                            <Text style={styles.goBackText}>Go Back</Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  
                </Surface> 
              </View>
            </div>
        : null
        
     }
     {
       props.response ?
       <div className='loginBox'>
         <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
       <Surface style={[styles.dialogBox, { marginRight: 10,marginLeft: 10,}]}>
       <View style={styles.details}>
           <View style={styles.iconDetails}>
           <Image source={successImage} style={{width:'100%', height:"100%"}}/>
           </View>
           
           <Text style={{...styles.mainTitle, color:'#239A14' , marginTop: 8}}>Payment Success</Text>
           <Text style={styles.subTitle}>your payment had completed successfully</Text>
     
       </View>
      </Surface> 
      </View>
      </div>
       : null

     }
    </>
  );
};

const styles = StyleSheet.create({
  dialogBox:{
      elevation: 5,
      marginVertical: 10,
      // marginHorizontal: 20,
     
      width: '80%',
      // height: hp('28%'),
      padding:20,
      borderRadius:10,
      minHeight: "28%",
     
  },
  details:{
      justifyContent:'center',
      alignItems:'center',
      flexDirection:'column',
      marginBottom: 16
  },
  iconDetails:{
     width:80,
     height:80,
     alignItems:'center',
     justifyContent:'center'
  },
  mainTitle: {
    fontSize:14,
    fontWeight:"500",
    color:'#2E2E2E',

  },
  subTitle:{
      fontSize:12,
      color:Styles.testSeriesListColor, 
      marginVertical:5,
      
  },
  goBackWrapper: {
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      marginVertical: 'auto'

      // marginBottom: 20,
     
      // borderWidth: 1
  },
  goBackText: {
      fontSize: 18,
      color: Styles.testSeriesListColor,
      textTransform:'uppercase'
  },
  userPaymentInfo: {
      position: 'absolute',
      bottom: 10,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: '95%',
      alignSelf: 'center'
  },
  userPaymentInfoText: {
      color: 'rgba(0,0,0,0.7)',
      fontSize: 8,
      textAlign: 'center'
  },   
  productTitle: {
      fontSize: 20,
      fontWeight: '500'
  },
  productDescription: {
      fontSize: 14, 
      fontWeight: '500',
      marginVertical: 20
  },
  productPrice: {
      fontSize: 22, 
      fontWeight: '600'
  },
  productPurchaseButton: {
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderColor: Styles.primaryColor,
      borderRadius: 10,
      borderWidth: 1,
      width: '80%',
      alignSelf: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 'auto',
      marginBottom: 15
  },
  continueText: {
      fontSize: 16,
      color: Styles.primaryColor,
      fontWeight: '500',
      textTransform: 'uppercase'
  },
  cancelBtn: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      // marginVertical: 5    
  },
  cancelText: {
      fontSize: 14, 
      color: 'red'        
  },   

})

const mapStatesToProps = state => ({
  loading: state?.checkoutTestCreation?.loading,
  paymentErrorMessage: state?.checkoutTestCreation?.error,
  response: state?.checkoutTestCreation?.response,
  userDetails:
  state.homeData && state.homeData.userDetails && state.homeData.userDetails,
 
})
export default connect(mapStatesToProps, {checkoutCreateTest,})(withRouter(Payment));
